// extracted by mini-css-extract-plugin
module.exports = {"container":"closeButton_container__JNFiW","text":"closeButton_text__c94o8"};